import { call, put } from '@redux-saga/core/effects'
import { api, notify, apiErrorHandler } from 'services'
import {
  CreateChecklistMemberActions as Actions,
  CreateChecklistMemberRequestAction as RequestAction,
} from 'store/ducks/checklistMembers'

export function* createChecklistMemberRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action

  try {
    yield call(api.post, `auth/register/checklist-member`, postData)
    onSuccess && onSuccess()
    notify('success', 'Usuário adicionado ao Checklist com sucesso')
    yield put(Actions.success())
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error)
    onFailure && onFailure()
    notify('error', errorMessage)
    yield put(Actions.failure(errorMessage, validationErrors))
  }
}